import React from "react";
import Modal from "olive-react-myoneui/lib/Modal";
import Button from "olive-react-myoneui/lib/Button";
import { setConfigData } from "../../../../reducers/configSlice";
import { useDispatch } from "react-redux";
import { deleteExternalDoc } from "../../../../api/afterLogin/externalDocs";

const DeleteModal = ({ show, id, accessToken, setHide }) => {
    const dispatch = useDispatch();
    const handleDelete = async () => {
        let data = JSON.stringify({
            "id": id
        });
        const response = await deleteExternalDoc(data, accessToken);
        if(response === true) {
            dispatch(setConfigData({ success_doc: true }));
            setHide();
        }
    };
    
    return(
        <Modal
            show={show}
            // onHide={true}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName="certificate-modal px-3 py-3"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Delete Confirmation
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Are you sure you want to delete this item? Deleting it will remove it permanently. Please confirm your action to proceed.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="default" onClick={() => setHide()}>Close</Button>
                <Button variant="orange" onClick={handleDelete}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteModal;
